import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    '& .ant-modal-header': {
      padding: '32px 20px 16px 60px',
    },
    '& .ant-modal-body': {
      padding: '0 60px 32px 60px',
    },
  },

  emptyArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 158,
    border: `1px solid ${theme.colors.borderColor}`,
    backgroundColor: theme.colors.gray2,
  },

  select: {
    '& >.ant-row': {
      marginBottom: 12,
    },

    '& .ant-form-item-label': {
      lineHeight: '22px',
      marginBottom: 8,
    },
  },

  okButton: {
    '& span': {
      fontWeight: '600 !important',
    },
  },
  cancelButton: {
    color: `${theme.colors.bodyColor} !important`,
    borderColor: `${theme.colors.gray5} !important`,
  },
}));

export default useStyles;
